import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MegaMenuItem, MenuItem } from 'primeng/api';
import { interval, Subscription } from 'rxjs';
import { Loginservices } from 'src/app/login/login.services';
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']

})

export class HeaderComponent implements OnInit {
  headerList = [];
  loginusername = '';
  defaultpage = '';
  items: MenuItem[] | undefined;
  itemsright: MenuItem[] | undefined;
  useritems: MenuItem[] | undefined;
  idBaseMenu: MenuItem[] | undefined
  topMenu: MenuItem[] | undefined
  commonconfigsubMenu: MenuItem[] | undefined;
  commonmastersubMenu: MenuItem[] | undefined
  commonreportssubMenu: MenuItem[] | undefined
  megaitems: MegaMenuItem[] | undefined;
  userdata: any;
  activeMenu: string;
  renderer: any;
  currentUrl='';
  openIndex: number | null = null;
    sessionDuration: string = '00:00:00';
  private timerSub!: Subscription;
  loggedinorg = '';
  currentserver = '';
  serverData: any[] = [];
  currentVersion = "";



  constructor(private route: Router, private utilityservice: Utilityservice,private router: Router,private loginservice:Loginservices) {
    this.userdata = this.utilityservice.getLoggeduser();
    this.loginusername = this.userdata?.firstname;
    this.defaultpage = this.userdata.defaultpagemircroservice;
    this.currentVersion = this.userdata.currentVersion;
  }

  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  if (!target.closest('.custom-menubar')) {
    this.openIndex = null;
  }
}

  ngOnInit(): void {
    this.currentUrl = window.location.href; // Get the current URL on load
    this.getnavigation();
    this.getserverandorg();
    // start clock code
    const loginTimeStr = localStorage.getItem('loginTime');
    if (loginTimeStr) {
      const loginTime = new Date(loginTimeStr).getTime();

      this.timerSub = interval(1000).subscribe(() => {
        const now = new Date().getTime();
        const elapsed = now - loginTime;

        this.sessionDuration = this.formatDuration(elapsed);
      });
    }
// clock code end
  }

 
  navigateTohome() {    
    window.location.href = `${window.location.origin}` + this.defaultpage;

  }

  getnavigation() {
    const filesvalidationdata= this.utilityservice.fileacceptdata()
   localStorage.setItem('filevalidation',JSON.stringify(filesvalidationdata))
    this.utilityservice.getusernavigation({ userid: this.utilityservice.getLoggeduser().userid })
      .subscribe(res => {
        if (res.length > 0) {
          const data = res.filter(e => e.productid == '1'); //change productid to necessary productid of service    
          localStorage.setItem('userRights', JSON.stringify(data[0]))
          this.headerList = res
          let datanav = this.headerList.filter(a => a.istopmenu == 'N');
          datanav.sort((a, b) => a.productinitial.localeCompare(b.productinitial));
          let topnav = this.headerList.filter(a => a.istopmenu == 'Y');
          topnav.sort((a, b) => a.productinitial.localeCompare(b.productinitial));
          this.idBaseMenu = []
          this.idBaseMenu = [
            {
              label: 'Dropdownmoremenu',
              items: datanav.map(item => ({
                label: item.productinitial,
                icon: 'pi pi-book', // Assuming you want the same icon for all
                title: item.productname,
                command: () => {                  
                  window.location.href = `${this.returnurl(item.productinitial)}`;
                },
               
                  styleClass: this.isActive(this.returnurl(item.productinitial)) ? 'active-menu-item' : ''
              }))
            }
          ];
          this.topMenu = [
            {
              label: 'topmenu',
              items: topnav.map(item => ({
                label: item.productinitial,

                icon: '',
                  command: () => {                    
                  window.location.href = `${this.returnurl(item.productinitial)}`;

                },
                title: item.productname,
                styleClass: this.isActive(this.returnurl(item.productinitial)) ? 'active-menu-item' : ''

             
              }))
            }
          ];
          
     
          this.items =
            [
              ...this.topMenu[0].items,
              {
                label: 'More',
                icon: 'pi pi-list',
                items: this.idBaseMenu[0].items,
                title: 'Click to view More Products'
              }
            ]
            
         
        }
       // console.log(this.topMenu, "topmenu");
        //console.log(this.items, "items");


      }
      )
  }
  getserverandorg(){
    this.utilityservice.getserverandorg().subscribe({
       next: (response:any) => {
        this.serverData = response;
        this.loggedinorg = this.serverData[0].org;
        this.currentserver = this.serverData[0].server;
        if(this.currentserver=='P'){
          this.currentserver='Primary';
        } else if(this.currentserver=='S'){
          this.currentserver='Secondary';
        }else if(this.currentserver=='H'){
          this.currentserver='DR';
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  tolowercase(name) {
    return name.toLowerCase();
  }
doLogout(){
   this.utilityservice.logoutAndRedirect();
}

  doLogout_new() {
    let subdomain=window.location.hostname.split('.')[0]
    const host = window.location.hostname; // rasi.complinity.in
const parts = host.split('.');
const baseDomain = parts.slice(-2).join('.');

    this.utilityservice.logout().subscribe(res=>{
      if(baseDomain=="complinity.in" ||baseDomain=="complinity.com"||baseDomain=="complinity.info")
    {
      const paylaod={"subdomain":window.location.hostname.split('.')[0]}
    this.utilityservice.checkorginitial(paylaod).subscribe(res=>{
  if (res && res.length > 0) {
  if(subdomain=="rasi"){
    localStorage.clear();
    window.location.href="https://portal.rasiseeds.com/adfs/ls/?wa=wsignout1.0";}
    if(subdomain=="maxhealthcare"){
        localStorage.clear();
        window.location.href="https://maxcrm.maxhealthcare.com/adfs/ls/?wa=wsignout1.0";

    }
      }else{
              localStorage.clear();
              window.location.href = location.origin + "/common/#/login"

      }

},error=>{
  localStorage.clear();
  window.location.href = location.origin + "/common/#/login"
} )}

      
    });
  }

toggleSubmenu(index: number, hasSubmenu: any) {
  if (hasSubmenu) {
    this.openIndex = this.openIndex === index ? null : index;
  }
}
  myFunction() {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }
  returnurl(url) {
    const formattedUrl = url.toLowerCase().replace(/\s+/g, '');
    const generatedUrl = `${location.origin}/${formattedUrl}/#/${formattedUrl}`;    
    return generatedUrl;
  }



isActive(path: string): boolean { 
  return this.currentUrl===path
}
  ngAfterViewInit() {
    setTimeout(() => {
      this.currentUrl = window.location.href;
    }, 100); 
  }

   ngOnDestroy(): void {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  private formatDuration(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = this.pad(Math.floor(totalSeconds / 3600));
    const minutes = this.pad(Math.floor((totalSeconds % 3600) / 60));
    const seconds = this.pad(totalSeconds % 60);
    return `${hours}:${minutes}:${seconds}`;
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

}

